import http from '../httpService';
import axios from 'axios';
import {BASE_URL, token} from '../../utils/const';
// import {Toast} from '../../../utils/sweetAlert';
import {t} from 'react-switch-lang';
import Swal from 'sweetalert2';

const main = 'subprocesses';

export function getAllSubprocesses() {
  // return http.get(`/subprocesses`);
  return axios({
    method: 'GET',
    url: `${BASE_URL}/${main}`,
    headers: {
      Authorization: 'Bearer ' + token,
      Accept: '*/*',
    },
  });
}

export function getAllProcesses() {
  // return http.get(`/subprocesses`);
  return axios({
    method: 'GET',
    url: `${BASE_URL}/${main}?processId.greaterThan=0`,
    headers: {
      Authorization: 'Bearer ' + token,
      Accept: '*/*',
    },
  });
}
export function createSubprocess(payload) {
  return http.post('/subprocesses', payload);
}
export function deleteSubprocess(id) {
  return http.delete(`/subprocesses/${id}`);
}
export function updateSubprocess(payload) {
  return http.put('/subprocesses', payload);
}